import React from 'react';
import Select from 'react-select'
import Toggle from 'material-ui/Toggle';
import './style.css';
import FieldComponent from '../../../../../../components/field/index';
import LoadingComponent from '../../../../../../components/loading/index';
import appointments from '../../../../../../services/appointments/index';
import validation from './validation';
import patients from '../../../../../../services/patients/index';
import { withRouter } from 'react-router-dom';
import { format, startOfDay } from 'date-fns';
import movements from '../../../../../../services/movements/index';
import users from '../../../../../../services/users/index';
import { from24To12 } from '../../../../../../services/utilities';
const esLocale = require('date-fns/locale/es');

export default withRouter(class EditSingleComponent extends React.Component {
    state = {
        errors: {
            patient: "",
            time: "",
            name: "",
            lastname: "",
            diagnostic: "",
            doctor: "",
            pay: "",
            duration: "",
            pin: "",
            phone: ""
        },
        fields: {
            patient: "",
            name: "",
            lastname: "",
            diagnostic: "",
            time: "",
            doctor: "",
            pay: 0,
            description: "",
            duration: "",
            pin: "",
            phone: ""
        },
        hasNewPatient: true,
        patients: [],
        loading: true,
        chair: -1,
        date: null,
        durations: []
    }

    componentWillMount() {
        let {timestamp, chair} = this.props.match.params;
        let dateString = format(
            new Date(Number(timestamp)),
            "DD/MM/YYYY",
            {locale: esLocale},
        )
        let diagnostics = this.props.diagnostics.filter(diag => diag.status == "activo").map(
            diagnostic => ({label: diagnostic.name, value: diagnostic._id, name: "diagnostic"})
        )
        let doctors=this.props.doctors.filter(doc => doc.status == "activo").map(
            doctor => ({label: `${doctor.name} ${doctor.lastname}`, value: doctor._id, name: "doctor"})
        )
        let patients=this.props.patients.map(
            patient => ({label: `${patient.name} ${patient.lastname}`, value: patient._id, name: "patient"})
        )
        appointments.find({date: timestamp, chair: chair}, (err, allAppointments) => {
            let times = this.getInitialDates(allAppointments)
            this.setState({
                patients: patients,
                allDoctors: doctors,
                doctors: [],
                diagnostics: diagnostics,
                loading: false,
                appointments: allAppointments,
                allTimes: times,
                times: times,
                date: timestamp,
                chair: chair,
                dateString: dateString,
                allDurations: [
                    {label: "15 minutos", value: 0, name: "duration"},
                    {label: "30 minutos", value: 1, name: "duration"},
                    {label: "45 minutos", value: 2, name: "duration"},
                    {label: "60 minutos", value: 3, name: "duration"}
                ],
                durations: []
            })
        })
    }

    getInitialDates = (appointments) => {
        let dates = []
        for(var i = 8; i<20 ; i++) {
            for(var j=0; j<60 ; j+=15) {
                let minutes = j.toLocaleString('en', {minimumIntegerDigits:2});
                let timeString = `${i}:${minutes}`;
                let index = appointments.findIndex(appointment => appointment.time == timeString)
                if(index == -1)
                    dates.push({label: from24To12(timeString), value: timeString, name: "time"})
                else
                    j+=appointments[index].duration * 15
            }
        }

        return dates;
    }

    handleChangeSelect = (option) => {
        if(option) {
            let fields = Object.assign({}, this.state.fields);
            let errors = Object.assign({}, this.state.errors);
            fields[option.name] = option.value;
            errors[option.name] = "";
            this.setState({ fields: fields, errors: errors});
        }
    }

    handleChangeInput = (e) => {
        let {value, name} = e.target;
        let fields = Object.assign({}, this.state.fields);
        let errors = Object.assign({}, this.state.errors);
        fields[name] = value;
        errors[name] = "";
        this.setState({ fields: fields, errors: errors});
    }

    changeTime = (option) => {
        if(option) {
            let fields = Object.assign({}, this.state.fields);
            let errors = Object.assign({}, this.state.errors);
            fields[option.name] = option.value;
            errors[option.name] = "";
            let durations = this.filterTimes(option.value)
            appointments.find({date: this.state.date, time: option.value}, (err, appointments) => {
                let doctors = this.state.allDoctors.filter(doctor => {
                    for(var i=0; i<appointments.length; i++) {
                        if(doctor.value === appointments[i].doctor)
                            return false;
                    }
                    return true;
                })
                this.setState({ fields: fields, errors: errors, durations: durations, doctors: doctors});
            })
        }
    }

    timeToNumber = (time) => {
        let numbers = time.split(":");
        return 1*numbers[0] + numbers[1]/100;
    }

    getTimeInMinutes = (time) => {
        let numbers = time.split(":");
        let minutes = Number(numbers[0]) * 60 + Number(numbers[1])
        return minutes;
    }

    filterTimes = (date) => {
        let ndate = this.timeToNumber(date)
        let appointments = this.state.appointments.sort((a,b) => {
            let na = Math.abs(this.timeToNumber(a.time) - ndate), nb = Math.abs(this.timeToNumber(b.time) - ndate);
            return na-nb
        })

        let time;
        for(var i=0; i<appointments.length ; i++) {
            let number = this.timeToNumber(appointments[i].time)
            if(number > ndate){
                time = appointments[i].time
                break;
            }
        }
        if(!time)
            time="20:00"

        let timeMinutes = this.getTimeInMinutes(time), dateMinutes =  this.getTimeInMinutes(date);

        let diference = timeMinutes-dateMinutes
        if(diference >= 60)
            return this.state.allDurations

        let durations = []
        for(var i = 15; i<=diference ; i+=15) {
            durations.push({label: (i + " minutos"), value: (i - 15)/15, name: "duration"})
        }
        return durations;
    }

    addMovement = (patient, pay) => {
        if(Number(pay) > 0)
            movements.insert({
                patient: patient,
                pay: Number(pay),
                user: this.props.user._id,
                date: startOfDay(new Date()).getTime()
            })
    }

    submit = (e) => {
        e.preventDefault()
        let {errors, hasError} = validation(this.state.fields, this.state.errors, this.state.hasNewPatient, this.props.user);
        if(hasError) {
            this.setState({errors: errors})
        } else {
            users.findOne({status: "activo", pin: this.state.fields.pin}, (err, user) => {
                if(!user) {
                    let errors = Object.assign({}, this.state.errors)
                    errors.pin = "Pin incorrecto.";
                    this.setState({errors: errors});
                    return;
                }

                if(this.state.hasNewPatient) {
                    patients.insert({
                        name: this.state.fields.name,
                        lastname: this.state.fields.lastname,
                        phone: this.state.fields.phone
                    }, (err, patient) => {
                        this.props.addPatient(patient)
                        appointments.insert({
                            patient: patient._id,
                            time: this.state.fields.time,
                            diagnostic: this.state.fields.diagnostic,
                            doctor: this.state.fields.doctor,
                            pay: this.state.fields.pay,
                            description: this.state.fields.description,
                            date: this.state.date,
                            chair: this.state.chair,
                            duration: this.state.fields.duration,
                            user: user._id,
                            createdAt: startOfDay(new Date()).getTime()
                        }, (err, appointment) => {
                            this.addMovement(patient._id, this.state.fields.pay)
                            this.props.history.push(`/home/pick-day/${this.state.date}/${this.state.chair}`);
                        })
                    })
                } else {
                    appointments.insert({
                        patient: this.state.fields.patient,
                        time: this.state.fields.time,
                        diagnostic: this.state.fields.diagnostic,
                        doctor: this.state.fields.doctor,
                        pay: this.state.fields.pay,
                        description: this.state.fields.description,
                        date: this.state.date,
                        chair: this.state.chair,
                        duration: this.state.fields.duration,
                        user: user._id,
                        createdAt: startOfDay(new Date()).getTime()
                    }, (err, appointment) => {
                        this.addMovement(this.state.fields.patient, this.state.fields.pay)
                        this.props.history.push(`/home/pick-day/${this.state.date}/${this.state.chair}`);
                    })
                }
            })
        }
    }

    render() {
        if(this.state.loading)
            return <LoadingComponent />

        return (
            <div className="EditSingle">
                <div className="card">
                    <div className="card-header">
                        <p className="card-header-title">Agendar cita</p>
                        <div className="card-header-icon"
                            onClick={this.redirect}
                            style={{cursor: "default"}}
                        >
                            <p>{this.state.dateString} - Silla {this.state.chair}</p>
                        </div>
                    </div>
                    <div className="card-content">
                        <form id="form" onSubmit={this.submit}>
                            {this.state.patients.length > 0 &&
                            <div className="columns">
                                <div className="column is-half">
                                    <Toggle label="Nuevo cliente"
                                        labelStyle={{color: "#363636"}}
                                        labelPosition="right"
                                        toggled={this.state.hasNewPatient}
                                        onToggle= {(_,toggled) => this.setState({hasNewPatient: toggled})}
                                    />
                                </div>
                            </div>}
                            {!this.state.hasNewPatient && this.state.patients.length > 0 ?
                            <div className="field">
                                <label className="label">Cliente</label>
                                <div className="control">
                                    <Select
                                        name="form-field-name"
                                        value={this.state.fields.patient}
                                        onChange={this.handleChangeSelect}
                                        options={this.state.patients}
                                    />
                                    {this.state.errors.patient ? <p className="help is-danger">{this.state.errors.patient}</p> :
                                    <p><br /></p>}
                                </div>
                            </div> :
                            <React.Fragment>
                                <div className="columns">
                                    <div className="column is-half">
                                        <FieldComponent onInputChange={this.handleChangeInput}
                                            value={this.state.fields.name}
                                            error={this.state.errors.name}
                                            name="name"
                                            label="Nombre *" icon="user"
                                        />
                                    </div>
                                    <div className="column is-half">
                                        <FieldComponent onInputChange={this.handleChangeInput}
                                            value={this.state.fields.lastname}
                                            error={this.state.errors.name}
                                            name="lastname"
                                            label="Apellidos *"
                                        />
                                    </div>
                                </div>
                                <FieldComponent onInputChange={this.handleChangeInput}
                                    value={this.state.fields.phone}
                                    error={this.state.errors.phone}
                                    name="phone"
                                    label="Teléfono"
                                />
                            </React.Fragment>}
                            <div className="columns">
                                <div className="column is-half">
                                    <label className="label">Hora *</label>
                                    <div className="control">
                                        <Select
                                            value={this.state.fields.time}
                                            onChange={this.changeTime}
                                            options={this.state.times}
                                        />
                                        {this.state.errors.time ? <p className="help is-danger">{this.state.errors.time}</p> :
                                        <p><br /></p>}
                                    </div>
                                </div>
                                <div className="column is-half">
                                    <label className="label">Duración *</label>
                                    <div className="control">
                                        <Select
                                            value={this.state.fields.duration}
                                            onChange={this.handleChangeSelect}
                                            options={this.state.durations}
                                        />
                                        {this.state.errors.duration ? <p className="help is-danger">{this.state.errors.duration}</p> :
                                        <p><br /></p>}
                                    </div>
                                </div>
                            </div>
                            <div className="field">
                                <label className="label">Empleado</label>
                                <div className="control">
                                    <Select
                                        value={this.state.fields.doctor}
                                        onChange={this.handleChangeSelect}
                                        options={this.state.doctors}
                                    />
                                    {this.state.errors.doctor ? <p className="help is-danger">{this.state.errors.doctor}</p> :
                                    <p><br /></p>}
                                </div>
                            </div>
                            <div className="columns">
                                <div className="column is-half">
                                    <label className="label">Servicio *</label>
                                    <div className="control">
                                        <Select
                                            value={this.state.fields.diagnostic}
                                            onChange={this.handleChangeSelect}
                                            options={this.state.diagnostics}
                                        />
                                        {this.state.errors.diagnostic ? <p className="help is-danger">{this.state.errors.diagnostic}</p> :
                                        <p><br /></p>}
                                    </div>
                                </div>
                                <div className="column is-half">
                                    <FieldComponent onInputChange={this.handleChangeInput}
                                        value={this.state.fields.pay}
                                        error={this.state.errors.pay}
                                        name="pay"
                                        label="Pago *"
                                        type="number"
                                        icon="money-bill-alt"
                                    />
                                </div>
                            </div>
                            <FieldComponent onInputChange={this.handleChangeInput}
                                error={this.state.errors.pin}
                                value={this.state.fields.pin}
                                label="Pin *"
                                name="pin"
                                maxLength={4}
                                type="password"
                            />
                            <FieldComponent onInputChange={this.handleChangeInput}
                                value={this.state.fields.description}
                                name="description"
                                rows={3}
                                label="Descripción"
                                type="textarea"
                            />
                        </form>
                    </div>
                    <footer className="card-footer" style={{display: "flex", justifyContent: "flex-end", padding: 7}}>
                        <button className="button is-primary" type="submit" form="form">Agendar</button>
                    </footer>
                </div>
            </div>
        );
    }
})


// WEBPACK FOOTER //
// ./src/scenes/main-page/scenes/home/scenes/edit-single/index.js